import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["add_attributes"];
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
const getSanitizeConfig = () => {
  const _config$HTML = config.HTML,
    rest = _objectWithoutPropertiesLoose(_config$HTML, _excluded);
  rest.attributes = Object.assign({}, rest.attributes, {
    div: ['class']
  });
  return rest;
};
const HTML_NO_ADD_ATTRIBUTES_NO_REMOVE_CLASS = getSanitizeConfig();
export const sanitizeWithConfig = content => sanitize(content, HTML_NO_ADD_ATTRIBUTES_NO_REMOVE_CLASS);